"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("./external/microsoft.cognitiveservices.speech.sdk.bundle"); // TODO: [P1] This need to be fixed with a peer depending package, instead of a burnt in bundle.


var _default = window.SpeechSDK;
exports.default = _default;